module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-zelfstandig-naamwoord.json
// module id = 1313
// module chunks = 47798205421804